import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastrService, ToastPackage } from 'ngx-toastr';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-custom-toastr',
    templateUrl: './custom-toastr.component.html',
    styleUrl: './custom-toastr.component.scss',
})
export class CustomToastrComponent implements OnInit, OnDestroy {
    iconUrl: string = '';
    private timeoutId: any;

    constructor(
        public toastPackage: ToastPackage,
        public toastrService: ToastrService
    ) {}

    ngOnInit(): void {
        const toastType = this.toastPackage.toastType;

        // Set icon based on toast type
        switch (toastType) {
            case 'toast-success':
                this.iconUrl = 'assets/images/toastr_images/success.png';
                break;
            case 'toast-error':
                this.iconUrl = 'assets/images/toastr_images/error.png';
                break;
            case 'toast-warning':
                this.iconUrl = 'assets/images/toastr_images/warning.png';
                break;
        }

        // Use timeout from toast config or default to environment value
        const timeout: number =
            this.toastPackage.config?.timeOut ||
            Number(environment.toastrTimeout);
        this.timeoutId = setTimeout(() => {
            this.toastrService.remove(this.toastPackage.toastId);
        }, timeout);
    }

    ngOnDestroy(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    closeToast(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.toastrService.remove(this.toastPackage.toastId);
    }
}
